<template>
    <div>
        <div v-if="!cuiInput" class="padding-box">
            <div class="info-m3">
                <div class="upper-text">
                    <p class="m-0 bolder">Acțiunea 4.1.1</p>
                    <p class="m-0 bolder">Investiții în activități productive</p>
                    <p class="m-0">Consolidarea poziției pe piață a IMM-urilor afectate de pandemia COVID-19</p>
                </div>
                <img src="@/assets/images/M3/logo-smis-gri.svg" alt="" class="logoSmis top-logo" style="max-width: 150px;">
            </div>
            <div class="marginTop">
                <!-- <div class="flex items-center flexcolumn space-between">
                    <div class="info-block">
                        <img src="@/assets/images/warn-sign-big.png" style="width: 100px; height: 100px">
                        <div class="text-warn">
                            <p>
                                Măsura 4.1.1, cu o alocare aproximativă de 412 milioane de euro, va fi publicată în consultare publică în intervalul 2-12 iunie, urmând ca Apelul să fie <strong>lansat cel mai târziu la începutul lunii iulie 2022. Depunerea proiectelor se va face timp de 15 zile iar finalizarea contractării este prevăzută pentru mijlocul lunii octombrie 2022.</strong>
                            </p>
                            <p>
                                <strong>Cele aproximativ 412 milioane de euro sunt alocate astfel:</strong>
                            </p>
                            <p>
                                <strong>Granturi între 50.000 și 200.000 de euro</strong> pentru susținerea activităților din domeniul sănătate, învățământ și servicii pentru populație cum ar fi cele de înfrumusețare, coafor etc.
                            </p>
                            <p>
                                <strong>Granturi între 200.000 și 1 milion de euro</strong> pentru activitățile economice din domeniul producției, construcții, transport și depozitare, hoteluri și restaurante, reparații auto/moto etc.
                            </p>
                        </div>
                    </div>
                    <div class="custom-white-block-smaller">
                        <img src="@/assets/images/M3/facebook-post.png" alt="Facebook post">
                    </div>
                </div> -->
                <!-- <div class="flex items-center flexcolumn space-between">
                   <div class="counter-block">
                        <p class="title-counter">Timp rămas pentru conceperea proiectelor</p>
                        <p class="counter" :class="calculateDepunereTimer().days <= 5 ? 'red blinker' : ''">
                            <strong>{{ calculateDepunereTimer().days }}</strong> <span class="gray">zile</span>&nbsp;
                            <strong>{{ calculateDepunereTimer().hours }}</strong> <span class="gray">ore</span>&nbsp;
                            <strong>{{ calculateDepunereTimer().minutes }}</strong> <span class="gray">minute</span>
                        </p>
                        <p class="footer-counter">Data deschiderii apelului: <strong>21 martie 2021</strong> <a href="https://mfe.gov.ro/mipe-a-publicat-ghidul-consolidat-privind-granturile-de-investitii-pentru-imm-uri/" target="_blank" style="color: inherit; text-decoration: none">(vezi comunicat MIPE)</a></p>
                    </div>
                    <div class="custom-white-block">
                        <p class="period-title">Perioada de depunere a proiectelor</p>
                        <p class="period-info"><span class="green-text"><span style="font-size: 29px; font-weight: bold;">5</span> zile</span> (21 martie - 25 martie)</p>
                    </div>
                    <div class="wider-status-block">
                        <M3Amanare></M3Amanare>
                    </div>
                    <a href="https://www.facebook.com/groups/poc411" target="_blank" class="custom-white-block-smaller">
                        <img src="@/assets/images/M3/M3Sketch/image-facebook.png" alt="POC411 Facebook">
                        <div class="absolute-green-block"><p>Alătură-te discuțiilor din grupul dedicat POC 411</p></div>
                    </a>
                </div> -->
                <div class="flex flexcolumn space-between marginTopCustom">
                    <div class="status-block">
                        <img src="@/assets/images/warn-sign-big.png" style="width: 100px; height: 100px">
                        <div class="text-warn">
                            <p class="mt-3">
                                Măsura 4.1.1, cu o alocare aproximativă de 412 milioane de euro, va fi publicată în consultare publică în intervalul 2-12 iunie, urmând ca Apelul să fie <strong>lansat cel mai târziu la începutul lunii iulie 2022. Depunerea proiectelor se va face timp de 15 zile iar finalizarea contractării este prevăzută pentru mijlocul lunii octombrie 2022.</strong>
                            </p>
                            <p class="mt-3">
                                <strong>Cele aproximativ 412 milioane de euro sunt alocate astfel:</strong>
                            </p>
                            <p class="mt-3">
                                <strong>Granturi între 50.000 și 200.000 de euro</strong> pentru susținerea activităților din domeniul sănătate, învățământ și servicii pentru populație cum ar fi cele de înfrumusețare, coafor etc.
                            </p>
                            <p class="mt-3">
                                <strong>Granturi între 200.000 și 1 milion de euro</strong> pentru activitățile economice din domeniul producției, construcții, transport și depozitare, hoteluri și restaurante, reparații auto/moto etc.
                            </p>
                        </div>
                        <a class="mt-3" href="/aplicatii/m3-sketch">
                            <strong>Aplicația va fi disponibilă în curând</strong><br> (accesează proiectele tale)
                        </a>
                    </div>
                    <!-- <b-overlay :show="loading" :opacity="opacity" :blur="blur" :variant="progressVariant" class="status-block" rounded="lg">
                        <template #overlay>
                            <div class="loading-overlay" :class="progressError ? 'error-progress' : ''">
                                <p style="text-align: center; margin-bottom: 5px; font-size: 15px;" :style="progressWhite ? 'color: #ffffff !important' : ''">{{ loadingText }}</p>
                                <b-progress :value="value" :max="max" show-progress></b-progress>
                            </div>
                        </template>
                        <div >
                            <div class="logo-wrapper">
                                <img src="@/assets/images/M3/poc-status.png" alt="POC Status" class="status-logo">
                            </div>
                            <span class="m3-title">Verifică <span class="black">pre-eligibilitatea*</span> companiei tale 100% gratuit</span>
                            <p v-if="duplicateName" style="text-align: center; color: #34b694; font-size: 16px;">Această firmă va duplica proiectul {{ duplicateName }}</p>
                            <div class="cui-input">
                                <span>CUI</span>
                                <validation-observer ref="loginForm" #default="{ invalid }">
                                    <b-form>
                                        <b-form-group>
                                            <validation-provider
                                                #default="{ errors }"
                                                rules="required"
                                            >
                                                <b-form-input
                                                    id="cui"
                                                    v-model.trim="form.cui"
                                                    :state="errors.length > 0 ? false : null"
                                                    name="cui"
                                                    :class="{'is-invalid':formErrors !== ''}"
                                                    type="text"
                                                    placeholder="43743807"
                                                ></b-form-input>
                                                <small v-if="formErrors === ''" class="text-danger">{{ errors[0] }}</small>
                                            </validation-provider>
                                        </b-form-group>

                                        <b-button
                                            type="submit"
                                            class="buton-submit-cui"
                                            variant="primary"
                                            :disabled="invalid || (remainingInterogations === 0)"
                                            @click.prevent="sendCui()"
                                        >{{ buttonText }}
                                            <div v-if="loading" class="spinner-border text-primary" role="status"></div>
                                        </b-button>
                                    </b-form>


                                </validation-observer>
                            </div>
                            <p v-if="formErrors !== ''" class="text-danger mt-1 text-center">{{ formErrors }}</p>
                            <p v-if="remainingInterogations === 0" class="mt-4" style="text-align: center;">Pentru a putea interoga o companie, este necesară achiziționarea unei licențe din pagina <router-link to="/licente" style="color: inherit; text-decoration: none; font-weight: 600;">comandă licență</router-link>.</p>
                            <div class="termene-copy">
                                <span>Serviciu oferit în parteneriat cu</span>
                                <a href="https://termene.ro/" target="_blank">
                                    <img src="@/assets/images/M3/termenecolor.png" alt="Termene" class="mt-2">
                                </a>
                            </div>
                        </div>
                    </b-overlay> -->
                    <div class="news-block">
                        <div class="flex columnMobile p-3">
                            <img src="@/assets/images/M3/facebook-post.png" alt="Facebook post" width="100%">
                        </div>
                        <b-overlay :show="raportDownload">
                            <div class="flex columnMobile p-3">
                                <div>
                                    <p class="news-title">Salut <strong>{{ $store.getters['auth/user'] ? $store.getters['auth/user'].name : '' }}</strong>,</p>
                                    <p v-if="remainingInterogations !== 'unlimited'" class="news-info mt-4">Ai acces la {{ remainingInterogations }} interogări gratuite.</p>
                                    <p v-else class="news-info mt-4">Ai acces la un număr nelimitat de interogări.</p>
                                    <p v-if="remainingInterogations !== 'unlimited'" class="news-info mt-4">
                                        <strong>Interogări disponibile:</strong>
                                        <span :class="remainingInterogations === 0 ? 'red-text' : 'green-text'"> {{ remainingInterogations }}</span>
                                    </p>
                                    <p v-else class="news-info mt-4"><strong>Interogări realizate:</strong> <span class="green-text">{{ totalStatusCheck }}</span></p>
                                    <p v-if="remainingInterogations === 0">Pentru a putea interoga o companie, este necesară achiziționarea unei licențe din pagina <router-link to="/licente" style="color: inherit; text-decoration: none; font-weight: 600;">comandă licență</router-link>.</p>
                                    <p v-if="remainingInterogations !== 'unlimited'" class="news-info mt-4">
                                        Pentru acces la un număr nelimitat de interogări este necesar să
                                        achiziționezi din contul tău minim 1 licență pentru POCSketch
                                    </p>
                                    <p v-else class="news-info mt-4">
                                        Îți mulțumim că ești client POCSketch! Ai acces la un număr nelimitat de interogări cât și la raportul complet al companiilor interogate până în prezent.
                                    </p>
                                    <p class="news-info mt-3">Descarcă aici raportul complet al companiilor interogate</p>
                                    <div class="green-button" @click="downloadRaport()">Descarcă raport</div>
                                </div>
                            </div>
                        </b-overlay>
                    </div>
                    <div class="right-content">
                        <a href="https://www.facebook.com/groups/poc411" target="_blank" class="custom-white-block-smaller mb-4">
                            <img src="@/assets/images/M3/M3Sketch/image-facebook.png" alt="POC411 Facebook">
                            <div class="absolute-green-block"><p>Alătură-te discuțiilor din grupul dedicat POC 411</p></div>
                        </a>

                        <div class="goodwill-block">
                            <p style="font-size: 16px;"><strong>Apelează la un consultant</strong></p>
                            <p class="small-text">Ai o reducere de <strong class="green-text">1.000 de lei</strong> la pachetele de consultanță oferite de Goodwill Consulting.</p>
                            <p class="mt-2">Sună la:</p>
                            <p><strong>0757.118.296</strong></p>
                            <p class="mt-2">Sau transmite un e-mail la:</p>
                            <p><strong>rakossy.zsombor@gwconsulting.ro</strong></p>
                            <p class="mt-2">Și precizează că ești utilizator al platformei Smis.</p>
                            <img src="@/assets/images/gw-negru.png" alt="" style="max-width: 125px; margin: auto; height: auto; align-self: flex-start; ">
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="centered-items">

                <div class="pageFooterContainer">
                    <div class="pageFooterBtnsWrapper">
                        <a href="https://mfe.gov.ro/poc-ghidul-consolidat-aferent-actiunii-4-1-1-investitii-in-activitati-productive/" target="_blank"
                           class="pageFooterDownloadButton blue"
                        >Descarcă Ghidul<br> solicitantului<br>(consolidat)</a>
                    </div>
                    <div class="pageFooterBtnsWrapper">
                        <a href="https://mfe.gov.ro/consultare-publica-ghidul-pentru-contractarea-granturilor-de-catre-imm-uri/" target="_blank"
                           class="pageFooterDownloadButton yellow"
                        >Descarcă Ghidul<br> solicitantului<br>(consultativ v3)</a>
                    </div>
                    <div class="pageFooterBtnsWrapper">
                        <a href="https://smis.ro/finantari/poc411/" target="_blank"
                           class="pageFooterDownloadButton blue"
                        >Citește<br> recomandările<br> Smis</a>
                    </div>
                    <p class="analiza" style="width: 100%">
                        *Analiza este generată automat în baza eligibilității codurilor CAEN, a procentului scăderii cifrei de afaceri în anul 2020 raportat la anul 2019 și a altor condiții specifice din ghidul solicitantului. Vă rugăm să analizați prevederile suplimentare din ghidului solicitantului, precum: societatea nu se încadrarează în categoria "întreprindere în dificultate" conform Regulamentului (UE) nr. 651/2014 sau a altor prevederi ce nu permit analiza în mod automat (ex: profit din exploatare). Analiza este realizată cu titlu de informare în baza informațiilor publice primite prin API de la instituțiile statului. În cazul în care există informații lipsă, analiza nu va fi returnată în mod corect. Statusul de companie ELIGIBILĂ sau după caz NEELIGIBILĂ nu atrage după sine răspunderea platformei Smis. Vă rugăm să analizați personal eligibilitatea companiei în conformitate cu ghidul solicitantului, împreună cu contabilul companiei sau un consultant specializat. Sursa oficială de informare: <a href="https://mfe.gov.ro/" target="_blank" class="green-text">https://mfe.gov.ro/</a>
                    </p>
                    <img src="@/assets/images/M3/M3Sketch/warn-sign-big.png" style="width: 50px; margin-right: 10px; padding-top: 10px; height: auto;">
                </div>
            </div> -->
            <div class="mobile-navigation">
                <router-link class="nav-btn" to="/aplicatii/m3-sketch">PocSketch</router-link>
                <router-link class="nav-btn" to="/aplicatii/m3-status">PocStatus</router-link>
            </div>
        </div>
        <M3StatusRaport v-else :data="data" :data2="data2" :termeneV3="termeneV3"
                        @backCuiInput="cuiInput = false; form.cui = ''; buttonPressed = false"
                        @newCompanyAdded="$emit('newCompanyAdded', $event)"
        ></M3StatusRaport>
    </div>
</template>

<script>
import {BForm, BFormGroup, BFormInput, BButton, BOverlay, BProgress, BProgressBar} from 'bootstrap-vue';
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import M3StatusRaport from './M3StatusRaport'
import M3Amanare from './components/M3Amanare'
import api from '@/helpers/api';
import axios from '@/helpers/axios';
import _ from "lodash";

require('@/helpers/validations/validations')
export default {
    name: 'M3Status',
    components: {
        BForm,
        BFormGroup,
        BFormInput,
        BButton,
        BOverlay,
        ValidationProvider,
        ValidationObserver,
        M3StatusRaport,
        BProgress,
        BProgressBar,
        M3Amanare
    },
    beforeRouteLeave (to, from, next) {
        this.$store.dispatch('pageLoading/setLoading', true)
        next()
    },
    data() {
        return {
            form: {
                cui: null,
            },
            data: null,
            data2: null,
            termeneV3: null,
            cuiInput: false,
            formErrors: '',
            loading: false,
            loadingText: 'Compania este in curs de interogare.',
            opacity: 0.98,
            value: 0,
            max: 100,
            blur: '20px',
            progressError: '',
            buttonText: 'Verifică acum',
            progressVariant: 'light',
            progressWhite: false,
            totalStatusCheck: '',
            datePush: null,
            raportDownload: false,
            duplicateName: null,
            buttonPressed: false,
            remainingInterogations: 0
        }
    },
    computed: {
        stateAids() {
            return this.$store.getters['stateAids/getStateAids']
        }
    },
    mounted() {
        axios.get(api.API_ENDPOINTS.m3StatusRemianingInterogations)
            .then(response => {
                this.remainingInterogations = response.data.remaining;
                this.getLicenseData()
            })
        this.$store.dispatch('stateAids/removeAids')
        if(this.$route.query && this.$route.query.duplicate){
            axios.get(api.API_ENDPOINTS.duplicateCompany + this.$route.query.duplicate)
                .then(response => {
                    if(response.data)
                        this.duplicateName = response.data.name;
                    else
                        this.duplicateName = null;
                })
        }
        else{
            this.duplicateName = null;
        }
    },
    methods: {
        calculateDepunereTimer() {
            let currentTime = new Date();
            let expire = new Date('2022-03-25T23:59:00');
            let distance = expire - currentTime;
            let timer = {
                days: Math.floor(distance / (1000 * 60 * 60 * 24)),
                hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
                seconds: Math.floor((distance % (1000 * 60)) / 1000),
            }
            return timer;
        },
        sendCui() {
            this.progressError = false
            this.loading = true
            this.buttonText = ''
            if(!this.buttonPressed) {
                this.buttonPressed = true
                axios.get(api.API_ENDPOINTS.m3 + this.form.cui + '/v1')
                    .then(response => {
                        this.value = 20
                        this.formErrors = ''
                        this.data = response.data;
                        if (response.data.codCaenPrincipalRecom !== false) {
                            axios.get(api.API_ENDPOINTS.m3 + this.form.cui + '/v2')
                                .then(response => {
                                    axios.get(api.API_ENDPOINTS.getStateAids + this.form.cui)
                                        .then( responseAids => {
                                            this.$store.dispatch('stateAids/setAids', responseAids.data)
                                            this.value = 40
                                            this.data2 = response.data;
                                            axios.get(api.API_ENDPOINTS.m3 + this.data2.cui + '/v3')
                                                .then(response => {
                                                    this.value = 60
                                                    this.termeneV3 = response.data;

                                                    let formSend = {
                                                        m1:  this.stateAids.m1 ?  (9679 / 4.8395).toFixed(0) : 0,
                                                        m2: this.stateAids.m2 ?  (Number(this.stateAids.m2['Suma solicitata']) / 4.8395).toFixed(0) : 0,
                                                        horeca: this.stateAids.horeca ?  (Number(this.stateAids.horeca['Suma solicitata']) / 4.9260).toFixed(0) : 0,
                                                        ca: (Number(this.data.CA_2019) / 4.946).toFixed(0)
                                                    }

                                                    let vechi = this.data.CA_2019 ? this.data.CA_2019 : 0;
                                                    let nou = this.data.CA_2020 ? this.data.CA_2020 : 0;
                                                    let difference = (vechi - nou) * 100 / vechi
                                                    if(difference < 0) {
                                                        difference = 0
                                                    }

                                                    let bilant2019 = _.filter(this.termeneV3.bilant_scurt, v => v.an === 2019)[0]
                                                    let bilant2020 = _.filter(this.termeneV3.bilant_scurt, v => v.an === 2020)[0]

                                                    axios.post(api.API_ENDPOINTS.m3MaxBudget, formSend)
                                                        .then(response => {
                                                            this.value = 80
                                                            this.datePush = {
                                                                cui: this.form.cui,
                                                                company_name: this.data2.nume,
                                                                caen: this.data.codCaenPrincipalRecom[0].cod_caen,
                                                                caen_secondary: this.data.coduriCaenSecundare.length,
                                                                score: this.getCADifference(this.data.CA_2019, this.data.CA_2020 ? this.data.CA_2020 : 0, this.data2.evaluation.criteria),
                                                                ca2019: this.data.CA_2019,
                                                                ca2020: this.data.CA_2020,
                                                                eligible: this.data2.isEligible,
                                                                angajati2019: this.data.nr_angajati_2019,
                                                                angajati2020: this.data.nr_angajati_2020,
                                                                cofinantare: ((this.data2.cofinancing !== 0 ? this.data2.cofinancing : 5 / 100) * Number(response.data.budget)).toFixed(0),
                                                                maxim_finantare: Number(response.data.budget).toFixed(0),
                                                                horeca: this.stateAids.horeca ?  Number(this.stateAids.horeca['Suma solicitata']) : 0,
                                                                m1: this.stateAids.m1 ?  Number(this.stateAids.m1['suma']) : 0,
                                                                m2: this.stateAids.m2 ?  Number(this.stateAids.m2['Suma solicitata']) : 0,
                                                                imm: this.data.imminvest ? this.data.imminvest[0].stare_solicitare : '',
                                                                capital2019: this.getCapital(2019),
                                                                capital2020: this.getCapital(2020),
                                                                statut_tva: this.data.statutTva,
                                                                cod_inmatriculare: this.termeneV3.cod_inmatriculare,
                                                                data_infintarii: this.termeneV3.data_infintarii,
                                                                forma_organizare: this.termeneV3.forma_organizare,
                                                                adresa: this.termeneV3.adresaAnafCompleta,
                                                                vechime: this.termeneV3.vechime,
                                                                ca_percent: parseFloat(difference).toFixed(2),
                                                                county: this.termeneV3.adresaAnaf.judet,
                                                                active_circulante_2019: bilant2019 && bilant2019.active_circulante ? bilant2019.active_circulante : '-',
                                                                active_circulante_2020: bilant2020 && bilant2020.active_circulante ? bilant2020.active_circulante : '-',
                                                                active_imobilizate_2019: bilant2019 && bilant2019.active_imobilizate ? bilant2019.active_imobilizate : '-',
                                                                active_imobilizate_2020: bilant2020 && bilant2020.active_imobilizate ? bilant2020.active_imobilizate : '-',
                                                                casa_si_conturi_la_banci_2019: bilant2019 && bilant2019.casa_si_conturi_la_banci ? bilant2019.casa_si_conturi_la_banci : '-',
                                                                casa_si_conturi_la_banci_2020: bilant2020 && bilant2020.casa_si_conturi_la_banci ? bilant2020.casa_si_conturi_la_banci : '-',
                                                                cheltuieli_in_avant_2019: bilant2019 && bilant2019.cheltuieli_in_avant ? bilant2019.cheltuieli_in_avant : '-',
                                                                cheltuieli_in_avant_2020: bilant2020 && bilant2020.cheltuieli_in_avant ? bilant2020.cheltuieli_in_avant : '-',
                                                                cheltuieli_totale_2019: bilant2019 && bilant2019.cheltuieli_totale ? bilant2019.cheltuieli_totale : '-',
                                                                cheltuieli_totale_2020: bilant2020 && bilant2020.cheltuieli_totale ? bilant2020.cheltuieli_totale : '-',
                                                                cifra_de_afaceri_neta_2019: bilant2019 && bilant2019.cifra_de_afaceri_neta ? bilant2019.cifra_de_afaceri_neta : '-',
                                                                cifra_de_afaceri_neta_2020: bilant2020 && bilant2020.cifra_de_afaceri_neta ? bilant2020.cifra_de_afaceri_neta : '-',
                                                                creante_2019: bilant2019 && bilant2019.creante ? bilant2019.creante : '-',
                                                                creante_2020: bilant2020 && bilant2020.creante ? bilant2020.creante : '-',
                                                                datorii_2019: bilant2019 && bilant2019.datorii ? bilant2019.datorii : '-',
                                                                datorii_2020: bilant2020 && bilant2020.datorii ? bilant2020.datorii : '-',
                                                                indicatori_2019: bilant2019 && bilant2019.indicatori ? bilant2019.indicatori : '-',
                                                                indicatori_2020: bilant2020 && bilant2020.indicatori ? bilant2020.indicatori : '-',
                                                                patrimoniu_public_2019: bilant2019 && bilant2019.patrimoniu_public ? bilant2019.patrimoniu_public : '-',
                                                                patrimoniu_public_2020: bilant2020 && bilant2020.patrimoniu_public ? bilant2020.patrimoniu_public : '-',
                                                                patrimoniu_regie_2019: bilant2019 && bilant2019.patrimoniu_regie ? bilant2019.patrimoniu_regie : '-',
                                                                patrimoniu_regie_2020: bilant2020 && bilant2020.patrimoniu_regie ? bilant2020.patrimoniu_regie : '-',
                                                                pierdere_brut_2019: bilant2019 && bilant2019.pierdere_brut ? bilant2019.pierdere_brut : '-',
                                                                pierdere_brut_2020: bilant2020 && bilant2020.pierdere_brut ? bilant2020.pierdere_brut : '-',
                                                                pierdere_net_2019: bilant2019 && bilant2019.pierdere_net ? bilant2019.pierdere_net : '-',
                                                                pierdere_net_2020: bilant2020 && bilant2020.pierdere_net ? bilant2020.pierdere_net : '-',
                                                                profit_brut_2019: bilant2019 && bilant2019.profit_brut ? bilant2019.profit_brut : '-',
                                                                profit_brut_2020: bilant2020 && bilant2020.profit_brut ? bilant2020.profit_brut : '-',
                                                                profit_net_2019: bilant2019 && bilant2019.profit_net ? bilant2019.profit_net : '-',
                                                                profit_net_2020: bilant2020 && bilant2020.profit_net ? bilant2020.profit_net : '-',
                                                                profit_pierdere_bruta_2019: bilant2019 && bilant2019.profit_pierdere_bruta ? bilant2019.profit_pierdere_bruta : '-',
                                                                profit_pierdere_bruta_2020: bilant2020 && bilant2020.profit_pierdere_bruta ? bilant2020.profit_pierdere_bruta : '-',
                                                                profitul_sau_pierdere_neta_2019: bilant2019 && bilant2019.profitul_sau_pierdere_neta ? bilant2019.profitul_sau_pierdere_neta : '-',
                                                                profitul_sau_pierdere_neta_2020: bilant2020 && bilant2020.profitul_sau_pierdere_neta ? bilant2020.profitul_sau_pierdere_neta : '-',
                                                                provizioane_2019: bilant2019 && bilant2019.provizioane ? bilant2019.provizioane : '-',
                                                                provizioane_2020: bilant2020 && bilant2020.provizioane ? bilant2020.provizioane : '-',
                                                                status_2019: bilant2019 && bilant2019.status ? bilant2019.status : '-',
                                                                status_2020: bilant2020 && bilant2020.status ? bilant2020.status : '-',
                                                                stocuri_2019: bilant2019 && bilant2019.stocuri ? bilant2019.stocuri : '-',
                                                                stocuri_2020: bilant2020 && bilant2020.stocuri ? bilant2020.stocuri : '-',
                                                                tip_activitate_2019: bilant2019 && bilant2019.tip_activitate ? bilant2019.tip_activitate : '-',
                                                                tip_activitate_2020: bilant2020 && bilant2020.tip_activitate ? bilant2020.tip_activitate : '-',
                                                                tip_bilant_2019: bilant2019 && bilant2019.tip_bilant ? bilant2019.tip_bilant : '-',
                                                                tip_bilant_2020: bilant2020 && bilant2020.tip_bilant ? bilant2020.tip_bilant : '-',
                                                                venituri_in_avans_2019: bilant2019 && bilant2019.venituri_in_avans ? bilant2019.venituri_in_avans : '-',
                                                                venituri_in_avans_2020: bilant2020 && bilant2020.venituri_in_avans ? bilant2020.venituri_in_avans : '-',
                                                                venituri_total_2019: bilant2019 && bilant2019.venituri_total ? bilant2019.venituri_total : '-',
                                                                venituri_total_2020: bilant2020 && bilant2020.venituri_total ? bilant2020.venituri_total : '-',
                                                            }
                                                            axios.post(api.API_ENDPOINTS.m3push, this.datePush)
                                                                .then(() => {
                                                                    this.value = 100

                                                                    this.totalStatusCheck++
                                                                    if(this.remainingInterogations !== 'unlimited')
                                                                        this.remainingInterogations--;
                                                                    if(this.remainingInterogations === 0){
                                                                        this.buttonText = 'Limita de interogări atinsă'
                                                                    }
                                                                    this.progressSuccess()

                                                                })
                                                                .catch(xhr => {
                                                                    if (xhr && xhr.response && xhr.response.status === 403) {
                                                                        this.formErrors = 'A fost atinsă limita maximă de încercări. Te rugăm să achiziționezi o licență.'
                                                                    }
                                                                    this.buttonPressed = false
                                                                    this.progressFailed()
                                                                })
                                                        })
                                                        .catch(xhr => {
                                                            if (xhr && xhr.response && xhr.response.status === 422) {
                                                                this.formErrors = 'Ne pare rău, pentru această companie nu găsim bilanțul pe anul 2019. Contactează-ne la office@smis.ro'
                                                            }
                                                            this.buttonPressed = false
                                                            this.progressFailed()
                                                        })
                                                })
                                        })
                                        .catch( xhr => {
                                            console.log(xhr);
                                        })
                                })
                        } else {
                            this.formErrors = 'CUI-ul introdus nu este valid. Contactează-ne la office@smis.ro'
                            this.form.cui = '';
                            this.progressFailed()
                            this.buttonPressed = false
                        }
                    })
                    .catch((xhr) => {
                        if (xhr && xhr.response && xhr.response.status === 429) {
                            this.formErrors = 'A fost atinsă limita maximă de încercări. Te rugăm să încerci în câteva minute.'
                            this.form.cui = '';
                            this.progressFailed()
                            this.buttonPressed = false
                        }
                        else{
                            this.formErrors = 'CUI-ul introdus nu este valid. Contactează-ne la office@smis.ro'
                            this.form.cui = '';
                            this.buttonPressed = false
                            this.progressFailed()
                        }
                    })
            }
        },
        getCADifference(ca2019, ca2020, score) {
            let vechi = ca2019
            let nou = ca2020
            let difference = (vechi - nou) * 100 / vechi
            if(difference < 0) {
                difference = 0
            }

            let points = 0
            if(difference <= 5) {
                points = 0
            } else if(difference >= 5 && difference < 10) {
                points = 15
            } else if(difference >= 10 && difference < 15) {
                points = 20
            } else if(difference >= 15 && difference < 20) {
                points = 25
            } else if(difference >= 20 && difference < 25) {
                points = 30
            } else if(difference >= 25 && difference < 30) {
                points = 35
            } else if(difference >= 30) {
                points = 40
            }

            let totalScore = 0
            score.forEach(item => {
                if(item.name === 'Scăderea cifrei de afaceri în anul 2020 în raport cu anul 2019') {
                    item.value = points
                }
                totalScore += item.value
            })
            return totalScore
        },
        progressFailed() {
            this.progressError = true
            this.loadingText = 'A apărut o eroare la interogare.'
            this.progressVariant = 'danger'
            setTimeout(() => {
                this.loading = false
                this.buttonText = 'Verifică acum'
                this.value = 0
                this.progressVariant = 'light'
                this.loadingText = 'Compania este in curs de interogare.'
            }, 1100)
        },

        progressSuccess() {
            this.progressVariant = 'success'
            this.loadingText = 'Compania a fost interogată cu succes.'
            this.progressWhite = true
            setTimeout(() => {
                this.progressVariant = 'light'
                this.loadingText = 'Compania este in curs de interogare.'
                this.progressWhite = false
                this.buttonText = 'Verifică acum'
                this.loading = false
                this.cuiInput = true
                this.value = 0
            }, 1100)
        },

        getLicenseData() {
            axios.get(api.API_ENDPOINTS.m3Licenses)
                .then( response => {
                    this.totalStatusCheck = response.data.status_checks
                    if(this.remainingInterogations === 0) {
                        this.buttonText = 'Limita de interogări atinsă'
                    }
                    else
                        this.buttonText = 'Verifică acum'
                })
        },
        getCapital(year){
            let response = '-';
            if(this.termeneV3 && this.termeneV3.bilant_scurt && this.termeneV3.bilant_scurt.length){
                this.termeneV3.bilant_scurt.forEach(bilant => {
                    if(Number(bilant.an) === Number(year))
                        response = bilant.capital_total
                })
            }
            return response;
        },
        downloadRaport() {
            this.raportDownload = true
            axios({url: api.API_ENDPOINTS.m3statusRaport, method: 'GET', responseType: 'blob'})
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'RAPORT COMPANII INTEROGATE - SMIS.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    this.raportDownload = false
                });
        }
    }
}
</script>

<style scoped>
/* LOADING */
.wider-status-block{
    width: 100%;
    max-width: 80%;
    border-radius: 6px;
}
.wider-status-block >>> .yellow-warn{
    border-radius: 6px;
}
.loading-overlay{
    width: 100%;
}
.loading-overlay >>> .progress{
    min-width: 350px;
}
.loading-overlay >>> .progress-bar{
    background-color: inherit;
    background: linear-gradient(to right,#69586e, #22686c);
}
.error-progress >>> .progress-bar{
    background: #ff7070 !important;
}
.error-progress >>> p{
    color: #fff !important;
}

.logoSmis.top-logo {
    max-height:110px;
}

.logo-wrapper {
    width: 100%;
    display: flex;
    margin-bottom: 20px;
    justify-content: center;
}
.status-logo {
    max-width: 230px;
    height: 45px;
}
.mobile-navigation {
    display: none;
}
.flex{
    display: flex;
}
.items-center{
    align-items: center;
}
.space-between{
    justify-content: space-between;
}
.status-block{
    background: #fff;
    border-radius: 6px;
    padding: 20px;
    width: 100%;
    max-width: 50%;
    min-height: 353px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
}
.status-block a {
    padding: 2px 45px;
    border-radius: 10px;
    text-align: center;
    text-decoration: none;
    font-size: 14px;
    background: linear-gradient(to bottom, #ffdf40, #ffdf40);
    color: #0b0b4b;
}
.counter-block{
    background: #3cc7a3;
    border-radius: 6px;
    padding: 20px;
    width: 100%;
    max-width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.period-title{
    font-size: 17px;
    color: #80859e;
}
.period-info{
    color: #3b4369;
    font-size: 17px;
}
.title-counter{
    font-size: 17px;
    color: #e4f4f0;
}
.footer-counter{
    font-size: 13px;
    color: #e4f4f0;
}
.counter{
    font-size: 29px !important;
    color: #ffffff;
    font-weight: 300;
    text-align: left;
}
.counter.red, .counter.red .gray{
    color: #eb8a9d;
}
.news-block{
    background: #fff;
    border-radius: 6px;
    width: 100%;
    max-width: 29%;
    min-height: 353px;
}
.custom-white-block{
    max-width: 29%;
    min-height: 130px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.custom-white-block, .custom-white-block-smaller{
    background: #fff;
    border-radius: 6px;
    width: 100%;
}
.custom-white-block-smaller{
    /* max-width: 19%; */
    min-height: 130px;
    max-height: 130px;
    position: relative;
}
.custom-white-block-smaller img{
    width: 100%;
    max-height: inherit;
    object-fit: cover;
    border-radius: 6px;
}
.absolute-green-block{
    position: absolute;
    right: 6px;
    bottom: 6px;
    background: #3cc7a3;
    max-width: 185px;
    padding: 8px;
    border-radius: 6px;
}
.absolute-green-block p{
    color: #fff;
    font-size: 13px;
    text-align: center;
}
.right-content {
    max-width: 19%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.goodwill-block{
    background: #fff;
    border-radius: 6px;
    width: 100%;
    min-height: calc(100% - (130px + 1.5rem));
    padding: 0.6rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.goodwill-block p{
    text-align: center;
    font-size: 14px;
    max-width: 280px;
}
.news-block .news-img{
    width: 100%;
}
.green-text{
    color: #3cc7a3;
}
.red-text{
    color: var(--dangerColor);
}
.green-button{
    background: #3cc7a3;
    color: #fff;
    font-size: 14px;
    padding: 8px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 150px;
    margin-top: 20px;
    cursor: pointer;
    transition: 0.4s;
}
.green-button:hover{
    background: #34b694;
}
.news-block:hover{
    text-decoration: none;
}
.news-title{
    font-size: 19px;
    color: #3b4369;
}
.news-info{
    font-size: 14px;
    color: #3b4369;
}
.marginTop{
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 40px;
}
.analiza {
    padding: 10px;
    font-size: 10px;
}

.info-m3 {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.info-m3 p {
    text-align: left;
    color: #848489;
    font-size: 12px;
}

.padding-box {
    padding: 30px;
}

.bolder {
    font-weight: 500;
}

.spinner-border {
    width: 1rem;
    height: 1rem;
}

.centered-items {
    height: 80%;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.marginTopCustom{
    margin-top: 20px;
}

.m3-title {
    font-size: 18px;
    color: #80859e;
    font-weight: 300;
    text-align: center;
    line-height: 45px;
    margin-top: 40px;
}

.black {
    font-weight: 800;
}

.cui-input {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 5px;
}

.cui-input >>> form {
    display: flex;
    align-items: center;
}

.form-group {
    margin-bottom: 0;
    max-height: 38px;
}

.cui-input span {
    font-size: 18px;
    color: #7e818f;
    margin-right: 10px;
}

form >>> input {
    background: transparent;
}

form >>> input:focus {
    box-shadow: none;
    border-color: #3b4369;
    background: transparent;
}

form >>> input::placeholder {
    opacity: 0.3;
}

form >>> button, form >>> .btn-primary.disabled {
    background: #3b4369;
    border-color: #3b4369;
    color: #fff;
    font-size: 15px;
    font-weight: 400;
    margin-left: 10px;
}

.termene-copy {
    display: flex;
    flex-direction: column;
    margin-top: 35px;
    align-items: center;
}

.termene-copy span {
    font-weight: 300;
    font-size: 18px;
    color: #3b4369;
}

.buton-submit-cui {
    min-width: 130px;
}

.buton-submit-cui:hover {
    background: #2F3554;
    border-color: #2F3554;
}

.buton-submit-cui:active, .buton-submit-cui:hover, .buton-submit-cui:focus {
    background: #2F3554 !important;
    border-color: #2F3554 !important;
}

.pageFooterContainer {
    background-color: #ffffff;
    width: 100%;
    display: flex;
    align-items: center;
    min-height: 120px;
}
.pageFooterContainer .analiza{
    align-self: flex-start;
}
.pageFooterBtnsWrapper {
    display: flex;
}
.pageFooterDownloadButton {
    width: 180px;
    padding: 2px 15px;
    height: 100px;
    background: linear-gradient(to bottom, #03b3da, #03c98c);
    margin: 10px;
    border-radius: 10px;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    text-decoration: none;
    font-size: 14px;
}
.pageFooterDownloadButton.blue {
    background: linear-gradient(to bottom, #036bd4, #03b8c7);
}
.pageFooterDownloadButton.yellow {
    background: linear-gradient(to bottom, #ffdf40, #ffdf40);
    color: #0b0b4b;
}
.guvern-logo{
    margin-top: 20px;
    max-width: 57px;
    max-height: 57px;
}
.min-height-limited{
    min-height: 395px;
}
@media (max-width: 1600px) {
    .padding-box {
        padding: 20px;
    }
    .centered-items {
        margin-top: 30px;
    }
    .m3-title[data-v-d50afc22] {
        font-size: 22px;
        line-height: 40px;
        margin-top: 20px;
    }
    .cui-input {
        display: flex;
        align-items: center;
        margin-top: 20px;
    }
    .min-height-limited{
        min-height: inherit;
    }
}
@media screen and (max-width: 1537px) {
    .marginTop {
        margin-top: 70px;
    }
}
@media (max-width: 1680px) {
    .marginTop {
        height: inherit;
    }
    .centered-items {
        margin-bottom: 30px;
    }
    .flexcolumn{
        flex-direction: column;
    }
    .info-m3{
        flex-direction: row;
    }
    .info-m3 .logoSmis{
        margin: 20px 0;
    }
    .right-content, .status-block, .news-block, .status-block, .goodwill-block, .custom-white-block-smaller, .custom-white-block, .counter-block, .wider-status-block {
        margin-right: 0;
        max-width: 100%;
    }
    .news-block, .custom-white-block-smaller, .custom-white-block{
        margin-top: 20px;
    }
    .guvern-logo{
        float: right;
    }
    .columnMobile{
        justify-content: space-between;
    }
}
@media screen and (max-width: 1281px) {
    .marginTop {
        margin-top: 30px;
    }
    .info-m3 .logoSmis{
        margin: 10px 20px;
    }
}
@media (max-width:1150px) {
    .pageFooterBtnsWrapper {
        flex-direction: column;
    }
    .pageFooterDownloadButton {
        width: calc(100% - 20px);
        padding: 2px 15px;
    }
}
@media screen and (max-width: 841px) {
    .info-m3 {
        flex-direction: column;
    }
    .upper-text {
        display: none;
    }
    .logoSmis.top-logo {
        max-height:60px!important;
    }
    .loading-overlay{
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .loading-overlay >>> .progress{
        min-width: 222px;
    }
}
@media screen and (max-width:767px) {
    .status-block, .news-block, .goodwill-block{
        min-height: auto;
        height: auto;
    }
    .info-m3 .logoSmis {
        margin: 0 0 10px 0;
        width: 30%;
    }
    .info-m3 img {
        max-width: 55% !important;
        margin: 0 auto;
    }
    .info-m3 p{
        text-align:center;
    }

    .m3-title {
        font-size: 16px!important;
        line-height: 20px!important;
    }
    .marginTop {
        margin-top: 20px;
    }
    .mobile-navigation{
        display: flex;
        justify-content: space-between;
        bottom: 0;
        width: 100%;
        align-content: center;
        align-items: center;
        background: black;
        padding: 10px 15px;
        position: fixed;
        left: 0;
    }
    .mobile-navigation .nav-btn {
        width: calc(50% - 10px);
        height: 40px;
        text-align: center;
        line-height: 40px;
    }
    .mobile-navigation .nav-btn:nth-of-type(1){
        background: linear-gradient(to bottom, #ce278f, #9b54d3);
        color:white;
        text-decoration: none;
        transition: all .2s ease-in-out;
    }
    .mobile-navigation .nav-btn:nth-of-type(1):hover{
        background: linear-gradient(to top, #ce278f, #9b54d3);
        color:white;
    }

    .mobile-navigation .nav-btn:nth-of-type(2){
        background: transparent;
        color:white;
        border: 1px solid white;
        transition: all .2s ease-in;
        text-decoration: none;
    }
    .mobile-navigation .nav-btn:nth-of-type(2):hover{
        background: white;
        color:black;
    }
    .news-title {
        padding-right: 15px;
    }

}
@media (max-width: 700px) {
    .centered-items {
        margin-bottom: 60px;
    }
    form {
        flex-direction: column;
    }

    form >>> button {
        margin-top: 22px;
        width: 100%;
        margin-left: 0!important;
    }
    .cui-input span {
        margin-right: 0;
    }
    .termene-copy {
        margin-top: 15px;
    }
    .termene-copy span {
        font-size: 16px;
        text-align: center;
    }
    .news-block {
        min-height: auto;
    }
    .news-block .news-img {
        object-fit: fill;
        max-width: 100%;
    }
}
@media (max-width:500px) {
    .pageFooterContainer {
        flex-direction: column;
        padding-top: 20px;
    }
    .pageFooterBtnsWrapper {
        width: 100%;
        order:3;
    }
}
</style>
